/**
 * Phase 8 T-17 §23.A — Topbar notifications trigger.
 *
 * Thin wrapper that owns the open/close state and binds the route-change
 * close behaviour (§23.D acceptance). Delegates rendering to
 * `NotificationsBell` + `NotificationsPanel` from the Notifications module.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@core/auth/useAuth';
import { useCalendarReminders } from '@core/hooks/useCalendarReminders';
import { NotificationsBell } from '@shared/components/Notifications/NotificationsPanel';

interface TopbarNotificationsProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TopbarNotifications({ open, onOpenChange }: TopbarNotificationsProps) {
  const { user } = useAuth();
  const { dueReminders } = useCalendarReminders(user?.orgId, user?.id);
  const location = useLocation();

  // §23.D: close panel on route change.
  useEffect(() => {
    if (open) onOpenChange(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <NotificationsBell
      open={open}
      onOpenChange={onOpenChange}
      unreadCount={dueReminders.length}
    />
  );
}
